import Button from 'components/Form/Button';
import { WALLET_VIEWS } from 'utils/billing';
import { FilterBar, FilterLabel } from './styled';

const OPTIONS = [
  { value: WALLET_VIEWS.open, label: 'Em aberto' },
  { value: WALLET_VIEWS.settled, label: 'Baixados' },
];

// Visao da Carteira: titulos em aberto (vencidos e a vencer) ou baixados.
// Entregue ao TableWrapper pela prop `filters`, ao lado da busca. Trocar a
// visao troca a query, e o useBillingList reconsulta o endpoint.
export default function WalletViewFilter({ value, onChange }) {
  return (
    <FilterBar>
      <FilterLabel>Títulos</FilterLabel>
      {OPTIONS.map((option) => (
        <Button
          key={option.value}
          color={value === option.value ? 'blue' : 'lightgrey'}
          small
          nospace
          width="auto"
          onClick={() => value !== option.value && onChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </FilterBar>
  );
}
